import React from "react";
import { useNavigate } from "react-router-dom";
import { createRoom, getBedsList, getRoomSizeType } from "adminApi/RoomApi/Room";
import { RoomRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddRoomForm from "./Components/AddRoomForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/RoomFields.json";
import useFetchAllData from "Hooks/useFetchAllData";

const AddRoom = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, RoomRules);

    const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(getRoomSizeType);
    const { data: bedTypeOptions, loading: loadingBedType } = useFetchAllData(getBedsList);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await createRoom({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, RoomRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room Created Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingRoomType || loadingBedType) && <Spinner isSpinner={true} />}
            <AddRoomForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => {
                    const sanitized = { ...values };
                    if (sanitized.exbed_capability !== "1") {
                        sanitized.exbed_capability_limit = 0;
                    }
                    handleSubmit(e, sanitized);
                }}
                loading={loadingSubmit}
                roomTypeOptions={roomTypeOptions || []}
                bedTypeOptions={bedTypeOptions || []}
            />
        </>
    );
};

export default AddRoom;
